import { render, staticRenderFns } from "./MemberWinloseSimple.vue?vue&type=template&id=436496e0&"
import script from "./MemberWinloseSimple.vue?vue&type=script&lang=js&"
export * from "./MemberWinloseSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports